function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M50,0c27.6,0,50,22.4,50,50s-22.4,50-50,50S0,77.6,0,50C0,22.4,22.4,0,50,0z M50,96.7                                                                     c25.7,0,46.7-21,46.7-46.7S75.8,3.3,50,3.3C24.3,3.3,3.3,24.2,3.3,50C3.3,75.7,24.3,96.7,50,96.7z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M52.6,29.6c0.6,0,1.1,0.2,1.5,0.6s0.6,0.9,0.6,1.5s-0.2,1.1-0.6,1.5L39,47.9h27.3c1.2,0,2.1,1,2.1,2.1                                                                         c0,1.2-1,2.1-2.1,2.1H39l15.1,14.7c0.4,0.4,0.6,0.9,0.6,1.5s-0.2,1.1-0.6,1.5c-0.4,0.4-0.9,0.6-1.5,0.6s-1.1-0.2-1.5-0.6                                                                         L32.5,51.7v-0.1l-0.2-0.1c-0.1-0.1-0.1-0.1-0.2-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.2-0.2-0.4-0.3-0.7c0-0.1,0-0.3,0-0.4                                                                         c0-0.1,0-0.3,0-0.4c0-0.2,0.1-0.5,0.3-0.7l0.1-0.1c0.1-0.1,0.1-0.2,0.2-0.2l0.1-0.1v-0.1l18.7-18.2C51.5,29.8,52,29.6,52.6,29.6z                                                                         "
}))));

var SvgBack = function SvgBack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "back",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/back.1a85299c.svg";
export { ForwardRef as ReactComponent };